import { useMemo, useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import ReactTable from "@ashvin27/react-datatable";
import axios from "axios";
import Pagination from "react-js-pagination";

const Projects = ({ auth }) => {
    const [records, setRecords] = useState([]);
    const [activePage, setActivePage] = useState(1);
    const [total, setTotal] = useState(0);
    const [pageSize, setPageSize] = useState(20);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const rawToken = localStorage.getItem("jwtToken");
                const token = rawToken?.replace("Bearer ", "");

                const res = await axios.get(`/api/projects?page=${activePage}&perPage=${pageSize}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const currentUserId = JSON.parse(atob(token.split(".")[1]))?.id;
                const projects = res.data?.projects || [];
                const formatted = projects.map((itm, index) => ({
                    srNo: (activePage - 1) * pageSize + index + 1,
                    id: itm?._id || index,
                    ticket: itm?.ticket,
                    name: itm?.name,
                    doNotComplete: itm.doNotCompleteById?.includes(currentUserId),
                }));
                setRecords(formatted);
                setTotal(res.data?.total || 0);
            } catch (error) {
                console.error("Error fetching projects:", error.message);
            }
        };

        fetchProjects();
    }, [activePage, pageSize]);

    const handleCheckboxChange = async (id) => {
        const prevRecords = [...records];
        const updated = records.map((item) =>
            item.id === id ? { ...item, doNotComplete: !item.doNotComplete } : item
        );
        const updatedItem = updated.find(item => item.id === id);

        setRecords(updated);

        try {
            const rawToken = localStorage.getItem("jwtToken");
            const token = rawToken?.replace("Bearer ", "");
            await axios.patch(`/api/projects/${id}/doNotComplete`, {
                doNotCompleteById: updatedItem.doNotComplete,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
        } catch (err) {
            console.error("Failed to update status:", err.message);
            setRecords(prevRecords);
        }
    };
    const columns = useMemo(() => [
        {
            key: "srNo",
            text: "S.No",
            className: "srNo",
            align: "left",
            sortable: true,
        },
        {
            key: "ticket",
            text: "Project Key",
            className: "ticket",
            align: "left",
            sortable: true,
            cell: (record) => record?.ticket || "N/A",
        },
        {
            key: "name",
            text: "Project Name",
            className: "name",
            align: "left",
            sortable: true,
        },
        {
            key: "doNotComplete",
            text: "Do Not Report",
            className: "do-not-complete",
            align: "left",
            sortable: false,
            cell: (record) => (
                <div className="text-start">
                    <input
                        type="checkbox"
                        checked={record.doNotComplete}
                        onChange={() => handleCheckboxChange(record.id)}
                    />
                </div>
            ),
        },
    ], [records]);

    const fullColumns = useMemo(() => {
        return auth?.user?.role === 1
            ? columns
            : columns;
    }, [columns, auth?.user]);

    const config = {
        page_size: pageSize,
        length_menu: [20, 30, 50],
        filename: "Projects",
        no_data_text: "No projects found!",
        button: {
            excel: true,
            print: true,
            csv: true,
        },
        language: {
            length_menu: "Show _MENU_ results per page",
            filter: "Filter in records...",
            info: "Showing _START_ to _END_ of _TOTAL_ records",
            pagination: {
                first: "First",
                previous: "Prev",
                next: "Next",
                last: "Last"
            }
        },
        show_length_menu: true,
        show_filter: true,
        show_pagination: false,
        show_info: true,
    };

    const handleTableChange = ({ page_size }) => {
        if (page_size && page_size !== pageSize) {
            setPageSize(page_size);
            setActivePage(1);
        }
    };

    return (
        <div className="wrapper">
            <Navbar />
            <div className="d-flex" id="wrapper">
                <Sidebar />
                <div id="page-content-wrapper">
                    <div className="container-fluid px-2 backdrop-cont">
                        <div className="mt-2">
                            <div className="d-flex align-items-center">
                                <button
                                    className="btn btn-link"
                                    id="menu-toggle"
                                    onClick={() => {
                                        document.body.classList.toggle("sidebar-expanded");
                                    }}
                                >
                                    <FontAwesomeIcon icon={faList} />
                                </button>
                                <h5 className="text-primary mb-0">Projects</h5>
                            </div>
                        </div>
                        <div className="task-table px-2 mt-3">
                            <ReactTable
                                config={config}
                                records={records}
                                columns={fullColumns}
                                onChange={handleTableChange}
                            />
                        </div>
                        <div className="d-flex justify-content-center my-3">
                            <Pagination
                                activePage={activePage}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={total}
                                pageRangeDisplayed={5}
                                onChange={(pageNumber) => setActivePage(pageNumber)}
                                nextPageText="Next"
                                prevPageText="Prev"
                                firstPageText="First"
                                lastPageText="Last"
                                itemClass="page-item"
                                linkClass="page-link"
                                activeClass="active"
                                activeLinkClass="active"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Projects;
